import * as React from 'react';
import * as moment from 'moment';
import { IDonorRegistration } from "@nkr/models/donor-registration";
import { Col, Row } from 'react-bootstrap';
import { getBoolean } from './renderers';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration,
}

const LostWageReimbursementInfo = ({ data }: IProps) => {
    return (
        <div id='lost-wage-reimbursement-info' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Donor has Applied for Lost Wage Reimbursement</span>
                </div>
                <Row>
                    <Col xs={6} sm={4}><strong>Current Status:</strong></Col>
                    <Col xs={6} sm={8}>
                        <span className={`label label-${data.wageReimbursementStep == 'Denied' ? 'danger' : 'success'} label-full`}>
                            {data.wageReimbursementStep}
                        </span>
                        &nbsp;
                    </Col>
                    <Col xs={6} sm={4}><strong>Surgery Scheduled:</strong></Col>
                    <Col xs={6} sm={8}>
                        {data.surgeryScheduledDateTime == null ? '[not entered]' : moment(data.surgeryScheduledDateTime).format('M/D/YYYY')}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4}><strong>Surgery Confirmed?</strong></Col>
                    <Col xs={6} sm={8}>
                        {getBoolean(data.isSurgeryScheduleConfirmed)}
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default LostWageReimbursementInfo;